/* eslint-disable */
import get from 'lodash/get'
import filter from 'lodash/filter'
import findIndex from 'lodash/findIndex'
import sum from 'lodash/sum'
import map from 'lodash/map'
import range from 'lodash/range'

import _ from 'underscore'
import * as THREE from 'three'

export default function getVectorsFromPolynomial(polynomial) {
    const px = get(polynomial, 'polynomial_x')
    const py = get(polynomial, 'polynomial_y')
    const pz = get(polynomial, 'polynomial_z')
    const tEnd = +polynomial.api_end_time

    // const tEndMs = Math.round(1000 * tEnd),
    const tPlate = +polynomial.api_plate_time
    const tPlateMs = Math.round(1000 * tPlate)
    // const tTrackEndMs = Math.min(tEndMs, tPlateMs);
    const tTrackEndMs = tPlateMs

    const pfx = pf(px)
    const pfy = pf(py)
    const pfz = pf(pz)

    const useGivenInterval = false
    const heightThreshold = 0
    // var interval = hitSegment.trajectoryData.validTimeInterval;
    const hit = []
    const start = useGivenInterval ? hit.result.hit.interval[0] : 0
    const end = useGivenInterval ? hit.result.hit.interval[1] : 7
    const step = 0.05
    const pathLen = Math.ceil((end - start) / step)
    let path = new Float32Array(3 * pathLen)

    for (let i = 0; i < pathLen; i++) {
        const p = path.subarray(3 * i, 3 * i + 3)
        const t = start + i * step
        p[0] = pfx(t)
        p[1] = pfy(t)
        p[2] = pfz(t)
    }

    let points = _.values(_.groupBy(path, (n, i) => Math.floor(i / 3)))

    if (!useGivenInterval) {
        points = clipHeadToPlate(points)
        points = clipTailToHeightThreshold(points, heightThreshold)
    }
    path = _.flatten(points)

    const vectors = []
    for (let i = 0; i < points.length; i++) {
        vectors.push(
            new THREE.Vector3(points[i][0], points[i][1], points[i][2])
        )
    }

    return vectors
}

/**
 * Limits to points up to first point that falls below given height threshold
 * @param points
 * @param height
 */
function clipTailToHeightThreshold(points, height) {
    const halfPoints = 0.5 * points.length

    const i = findIndex(points, (p, i) => i >= halfPoints && p[2] < height)

    if (i !== -1) {
        return points.slice(0, i)
    }

    return points
}

/**
 * Filters out points behind the tip of the plate
 * @param points
 */
function clipHeadToPlate(points) {
    return filter(points, (p) => p[1] >= 0)
}

function terms(n, coef) {
    return map(coef, (c, i) => c * n ** i)
}

function val(n, coef) {
    return sum(terms(n, coef))

    // if pre-processing, round to 2 decimal places (or even just 1?)
    // return _.round(_.sum(terms(n, coef)), 2)
}

/**
 * Generates xyzt samples at specific times
 *  @param polynomial - coefficients
 * @param times - array of sample times, in ms
 */
function toSamples(polynomial, times) {
    let tSec

    return times.map((t) => {
        tSec = t / 1000

        return {
            t,
            x: val(tSec, polynomial.x),
            y: val(tSec, polynomial.y),
            z: val(tSec, polynomial.z),
        }
    })
}

/**
 * Generates xyzt samples at even intervals
 * @param polynomial - coefficients
 * @param extent - array of in and out times, in ms
 * @param interval - time between samples, in ms
 */
const SAMPLE_INTERVAL = 34

function toSamplesEven(polynomial, extent, interval = SAMPLE_INTERVAL) {
    const times = range(extent[0], extent[1], interval)

    times.push(extent[1])

    return toSamples(polynomial, times)
}

function clampY(points, y = 1.4) {
    return map(points, (p) => ({
        x: p.x,
        y: Math.max(y, p.y),
        z: p.z,
    }))
}

function pf(coef) {
    return function (val) {
        let sum = 0
        if (coef) {
            for (let i = coef.length - 1; i >= 0; i--) {
                const c = coef[i]
                sum += c * val ** i
            }
        }
        return sum
    }
}
